import { createReducer, SUCCESS, updateObject } from 'Stores'
import { GET_ACCOUNT_INFO } from './constants'

export const initialState = {
  type: null,
  accountInfo: {}
}

function getAccountInfoSuccess(state, { payload }) {
  const { accountInfo } = payload
  return updateObject(state, {
    accountInfo
  })
}

export default createReducer(initialState, {
  [SUCCESS(GET_ACCOUNT_INFO)]: getAccountInfoSuccess
})
